import React from "react";
import "./Projects.css";
export const Pj = ({icons, gifSource, headers, liveCode, sourceCode, main, body }) => {
    return (
        <>
            
        <div className="projects_container" key={Math.random()}>
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src={gifSource}
                  alt=""
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>{headers}</h2>
              <p>
                {main}
                <br />
                <br />
                {body}
              </p>
              <div>
                {
                    icons && icons.map((item) => <div key={Math.random()}>{item}</div>) 
                }
              </div>
              <div>
                <a
                  href={liveCode}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                {
                  sourceCode && 
                <a
                  href={sourceCode}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
                }
              </div>
            </div>
          </div>
        </div>

        </>
    )
}
